import { Injectable } from "@angular/core";

import moment from "moment";

import { IdNatPSPipe } from "../../shared/pipes/id-nat-ps.pipe";
import { IdNatStructurePipe } from "../../shared/pipes/id-nat-structure.pipe";
import { PersonnePhysiqueDto } from "../../models/personne-physique-dto.model";
import { Structure } from "../../models/structure.model";

@Injectable({
  providedIn: 'root'
})
export class ComparatorService {

  constructor(
    private idNatPSPipe: IdNatPSPipe,
    private idNatStructurePipe: IdNatStructurePipe,
  ) { }

  /**
   * Sort data table field id nat column
   * @param a First element to compare
   * @param b Second element to compare
   * @returns
  */
  idNatPSComparator(a: PersonnePhysiqueDto, b: PersonnePhysiqueDto): number {
    return (this.idNatPSPipe.transform(a).toLowerCase() < this.idNatPSPipe.transform(b).toLowerCase()) ? -1 :
      (this.idNatPSPipe.transform(a).toLowerCase() > this.idNatPSPipe.transform(b).toLowerCase()) ? 1 : 0;
  }

  /**
   * Sort data table field id nat structure column
   * @param a First element to compare
   * @param b Second element to compare
   * @returns
  */
  idNatStructureComparator(a: Structure, b: Structure): number {
    return (this.idNatStructurePipe.transform(a).toLowerCase() < this.idNatStructurePipe.transform(b).toLowerCase()) ? -1 :
      (this.idNatStructurePipe.transform(a).toLowerCase() > this.idNatStructurePipe.transform(b).toLowerCase()) ? 1 : 0;
  }

  /**
   * Sort data table field text column
   * @param a First element to compare
   * @param b Second element to compare
   * @returns
  */
  textComparator(a: string, b: string): number {
    return (a.toLowerCase() < b.toLowerCase()) ? -1 : (a.toLowerCase() > b.toLowerCase()) ? 1 : 0;
  }

  /**
   * Sort data table field date column
   * @param a First element to compare
   * @param b Second element to compare
   * @returns
  */
  dateComparator(a: string, b: string): number {
    return (moment(a).isBefore(b)) ? -1 : (moment(a).isAfter(b)) ? 1 : 0;
  }

}
